import { Component, ElementRef, ViewChild } from '@angular/core';

import unformat from 'accounting-js/lib/unformat.js';
import UrlUtils from '@shared/Utils/url.utils';
import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './number-form-field.component.html',
  styleUrls: ['./../form-field.component.scss'],
})
export class NumberFormFieldComponent extends FormFieldComponent {
  @ViewChild('inputControl') inputControl: ElementRef;

  private _originalValue: any;

  public value: any;
  public editing: boolean = false;
  public precision: number = 0;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.fieldDef.meta?.value_hidden && !this.editing ? 'REDACTED' : this.model[this.fieldDef.name];

    this._originalValue = this.value;

    if (this.fieldDef.meta && this.fieldDef.meta.scale) {
      this.precision = this.fieldDef.meta.scale;
    }
  }

  edit(): void {
    if (!this.editing && !this.isReadonly && !this.fieldDef.meta?.value_hidden) {
      this.editing = true;
      setTimeout(() => {
        this.inputControl.nativeElement.focus();
      }, 300);
    }
  }

  onBlur(): void {
    this.value = UrlUtils.checkAndEvalFormula(this.value)?.toString();
    if (this.value === '') {
      this.value = null;
    }
    this.onSave();
    this.editing = false;
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.value = this.model[this.fieldDef.name];
    this._originalValue = this.value;
  }

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value ? this.value.replace(/,/g, '') : null });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = unformat(this.value);
    this._originalValue = unformat(this.value);
  }
}
